import { render } from "./add-role.vue?vue&type=template&id=405bceb3"
import script from "./add-role.vue?vue&type=script&lang=js"
export * from "./add-role.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__